var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1135.899,
    height: 1158.313,
    viewBox: "0 0 1135.899 1158.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-directions",
    "data-name": "Icon awesome-directions",
    d: "M1115.067,527.839l-496.8-506.6a70.213,70.213,0,0,0-100.634,0l-496.8,506.6a73.6,73.6,0,0,0,0,102.618l496.8,506.6a70.173,70.173,0,0,0,100.634,0l496.8-506.6a73.6,73.6,0,0,0,0-102.618Zm-224.03,28.414L704.213,732.1c-11.359,10.7-29.8,2.489-29.8-13.3V597.246H461.437V742.033a17.921,17.921,0,0,1-17.748,18.1H372.695a17.921,17.921,0,0,1-17.748-18.1V561.049c0-39.975,31.792-72.393,70.994-72.393H674.418V367.1c0-15.768,18.414-24,29.8-13.3L891.038,529.648a18.356,18.356,0,0,1,0,26.6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/directionIcon.d1237e714c65f5c57717e580d33743f3.svg";
export { ForwardRef as ReactComponent };